import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MemberEvaluationService } from '../../../../../app/members/member-evaluation.service';

@Component({
  selector: 'app-evaluation-expired',
  templateUrl: './evaluation-expired.component.html',
  styleUrls: ['./evaluation-expired.component.scss'],
  standalone: false
})
export class EvaluationExpiredComponent implements OnInit, OnDestroy {
  private _subscription: Subscription;

  constructor(private service: MemberEvaluationService) {}

  ngOnInit(): void {
    this._subscription = this.service.evaluation.subscribe((result) => {
      if (result) {
        this.service.setEvaluationForm();
      }
    });
  }

  ngOnDestroy(): void {
    if (this._subscription) this._subscription.unsubscribe();
  }
}
